module.exports = __webpack_public_path__ + "img/no-image.bb96eec4.jpg";